import type { Release } from '../types';
import arc from './releases/arc';
import brakeDearSide from './releases/brakeDearSide';
import brakeRobotSide from './releases/brakeRobotSide';
import clsr from './releases/clsr';
import flashOfEnergy from './releases/flashOfEnergy';
import outOfOrder from './releases/outOfOrder';
import purity from './releases/purity';
import toughLove from './releases/toughLove';

const releaseData: Release[] = [
  toughLove,
  brakeDearSide,
  brakeRobotSide,
  purity,
  outOfOrder,
  arc,
  clsr,
  flashOfEnergy,
];

export default releaseData;
